import { Link, useNavigate } from 'react-router-dom';
import {
    Box,
    Flex,
    Button,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    useDisclosure,
    Heading,
} from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { isAdmin } from '../../utils/string.utils';

export const Navbar = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const navigate = useNavigate();

    if (!isAdmin) {
        navigate('/logout');
    }

    return (
        <Box bg="primary.500" px={4}>
            <Flex h={16} alignItems="center" justifyContent="space-between">
                <Heading pt={3} as={'h1'} color="white" fontWeight="bold" fontSize="lg">
                    <Link to="/" style={{ textDecoration: 'none', color: 'white' }}>
                        Falcon Admin
                    </Link>
                </Heading>
                <Flex alignItems="center">
                    <Menu isOpen={isOpen}>
                        <MenuButton
                            as={Button}
                            colorScheme="primary"
                            onMouseEnter={onOpen}
                            onMouseLeave={onClose}
                            rightIcon={<FontAwesomeIcon icon={faChevronDown} />}
                        >
                            IAM
                        </MenuButton>
                        <MenuList onMouseEnter={onOpen} onMouseLeave={onClose}>
                            <MenuItem as={Link} to="/roles">
                                Roles
                            </MenuItem>
                            <MenuItem as={Link} to="/permissions">
                                Permissions
                            </MenuItem>
                        </MenuList>
                    </Menu>
                    <Button as={Link} to="/inbox" variant="ghost" color="white" ml={4}>
                        Inbox
                    </Button>
                    <Button as={Link} to="/users" variant="ghost" color="white" ml={4}>
                        Users
                    </Button>
                    <Button as={Link} to="/carriers" variant="ghost" color="white" ml={4}>
                        Carriers
                    </Button>
                    <Button as={Link} to="/mappers" variant="ghost" color="white" ml={4}>
                        Mappers
                    </Button>
                    <Button as={Link} to="/states" variant="ghost" color="white" ml={4}>
                        States
                    </Button>
                    <Button as={Link} to="/report-configs" variant="ghost" color="white" ml={4}>
                        Reports
                    </Button>
                    <Button as={Link} to="/tenants" variant="ghost" color="white" ml={4}>
                        Tenants
                    </Button>
                    <Button as={Link} to="/admin" variant="ghost" color="white" ml={4}>
                        Admin
                    </Button>
                    <Button as={Link} to="/logout" variant="ghost" color="white" ml={4}>
                        Logout
                    </Button>
                </Flex>
            </Flex>
        </Box>
    );
};
